/**
 * Horizontal, infinitely-looping strip (posters or logo rows). The item list
 * is rendered twice back-to-back and animated by exactly -50% of the track
 * width via CSS, so the loop has no visible seam — same technique as the
 * hero's vertical PosterColumn, just on the X axis.
 */
export default function Marquee({
    items,
    renderItem,
    direction = 'left',
    duration = 40,
    delay = 0,
    className = '',
    trackClassName = '',
}) {
    const loopItems = [...items, ...items];

    return (
        <div className={`marquee ${className}`}>
            <div
                className={`marquee-track ${direction === 'right' ? 'marquee-track-right' : 'marquee-track-left'} ${trackClassName}`}
                style={{ animationDuration: `${duration}s`, animationDelay: `${delay}s` }}
            >
                {loopItems.map((item, i) => (
                    <div className="marquee-item" key={item.id ? `${item.id}-${i}` : i}>
                        {renderItem(item, i)}
                    </div>
                ))}
            </div>
        </div>
    );
}
